import React from "react";
import PropTypes from "prop-types";

/**
 * StyledMessage - A component for displaying styled text in snackbar messages
 * This allows for custom styling within the snackbar component
 */
const StyledMessage = ({ children, style = {}, className = "" }) => {
  return (
    <span className={className} style={style}>
      {children}
    </span>
  );
};

StyledMessage.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  className: PropTypes.string
};

export default StyledMessage;
